(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 9208:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(765);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4143:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Card; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_extends.mjs
var _extends = __webpack_require__(872);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./components/Button/index.tsx
var Button = __webpack_require__(8859);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(4924);
// EXTERNAL MODULE: ./styles/stitches.config.ts
var stitches_config = __webpack_require__(4767);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 6 modules
var polished_esm = __webpack_require__(7573);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./public/images/icons/leaf-bg-1.svg
/* harmony default export */ var leaf_bg_1 = ({"src":"/_next/static/media/leaf-bg-1.1045a309.svg","height":35,"width":41});
;// CONCATENATED MODULE: ./public/images/icons/leaf-bg-2.svg
/* harmony default export */ var leaf_bg_2 = ({"src":"/_next/static/media/leaf-bg-2.8cddd2e9.svg","height":40,"width":40});
;// CONCATENATED MODULE: ./components/Card/styles.ts






var Texts = (0,stitches_config/* styled */.zo)("div", {
    position: "relative",
    paddingInline: 25,
    "&::before": {
        content: "url(".concat(leaf_bg_1.src, ")"),
        visibility: "hidden",
        opacity: 0,
        position: "absolute",
        left: 20,
        top: 0,
        transition: "all 0.3s"
    },
    "&::after": {
        content: "url(".concat(leaf_bg_2.src, ")"),
        visibility: "hidden",
        opacity: 0,
        position: "absolute",
        right: 30,
        bottom: 10,
        transition: "all 0.3s"
    }
});
var Card = (0,stitches_config/* styled */.zo)("div", {
    position: "relative",
    textAlign: "center",
    borderRadius: 8,
    overflow: "hidden",
    border: "solid 1px",
    borderColor: "transparent",
    transition: "all 0.3s",
    "&:hover": (0,_define_property/* default */.Z)({
        border: "solid 1px",
        borderColor: "$emerald500",
        cursor: "pointer",
        transition: "all 0.3s"
    }, "& ".concat(Texts), {
        "&::before, &::after": {
            opacity: 1,
            visibility: "visible",
            transition: "all 0.3s"
        }
    })
});
var ImageWrap = (0,stitches_config/* styled */.zo)("figure", {
    position: "relative",
    width: "100%",
    height: 230,
    marginBottom: 14
});
var Image = (0,stitches_config/* styled */.zo)((image_default()), {});
var Title = (0,stitches_config/* styled */.zo)("h3", {
    marginBottom: 14,
    fontSize: "20px !important",
    color: "$grey900",
    lineHeight: "120%",
    fontFamily: "$domine",
    fontWeight: "bold",
    textTransform: "capitalize"
});
var Description = (0,stitches_config/* styled */.zo)("p", {
    marginBottom: 14,
    color: "$grey500",
    fontSize: (0,polished_esm/* rem */.hO)(15),
    fontFamily: "$raleway",
    lineHeight: "180%",
    overflow: "hidden",
    "text-overflow": "ellipsis",
    display: "-webkit-box",
    "-webkit-box-orient": "vertical",
    "-webkit-line-clamp": "2"
});

;// CONCATENATED MODULE: ./components/Card/index.tsx






var shimmer = function(w, h) {
    return '\n<svg width="'.concat(w, '" height="').concat(h, '" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n  <defs>\n    <linearGradient id="g">\n      <stop stop-color="#333" offset="20%" />\n      <stop stop-color="#222" offset="50%" />\n      <stop stop-color="#333" offset="70%" />\n    </linearGradient>\n  </defs>\n  <rect width="').concat(w, '" height="').concat(h, '" fill="#333" />\n  <rect id="r" width="').concat(w, '" height="').concat(h, '" fill="url(#g)" />\n  <animate xlink:href="#r" attributeName="x" from="-').concat(w, '" to="').concat(w, '" dur="1s" repeatCount="indefinite"  />\n</svg>');
};
var toBase64 = function(str) {
    return  false ? 0 : window.btoa(str);
};
var Card_Card = function(_param) {
    var props = (0,_extends/* default */.Z)({}, _param);
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        onClick: props.onPress,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWrap, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                    src: props.image,
                    title: props.metaImgTitle,
                    alt: props.metaImgTitle,
                    // placeholder="blur"
                    layout: "fill",
                    objectFit: "cover",
                    blurDataURL: "data:image/svg+xml;base64,".concat(toBase64(shimmer("100%", "100%")))
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Texts, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                        title: props.metaTitle,
                        children: props.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Description, {
                        children: props === null || props === void 0 ? void 0 : (ref = props.description) === null || ref === void 0 ? void 0 : ref.replace(/<[^>]*>?/gm, "")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        color: "transparent",
                        onClick: props.onPress,
                        children: "Ver detalhes"
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var components_Card = (Card_Card);


/***/ }),

/***/ 2556:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Headline; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_extends.mjs
var _extends = __webpack_require__(872);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./styles/stitches.config.ts
var stitches_config = __webpack_require__(4767);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 6 modules
var polished_esm = __webpack_require__(7573);
;// CONCATENATED MODULE: ./components/Headline/styles.ts


var Headline = (0,stitches_config/* styled */.zo)("div", {
    marginBottom: 25,
    textAlign: "center",
    "@xxl": {
        marginBottom: 50
    },
    variants: {
        color: {
            inverse: {
                "& h2": {
                    color: "$white"
                }
            }
        }
    },
    "& span": {
        color: "$emerald500"
    }
});
var Category = (0,stitches_config/* styled */.zo)("p", {
    position: "relative",
    marginBottom: 16,
    fontSize: (0,polished_esm/* rem */.hO)(12),
    color: "$emerald500",
    fontFamily: "$raleway",
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: 2,
    "@xxl": {
        fontSize: (0,polished_esm/* rem */.hO)(13)
    },
    "&::before": {
        content: "",
        position: "absolute",
        bottom: -4,
        width: 30,
        height: 2,
        left: "50%",
        transform: "translate(-50%,0)",
        backgroundColor: "$emerald500"
    }
});

;// CONCATENATED MODULE: ./components/Headline/index.tsx





var Text = function(_param) {
    var props = (0,_extends/* default */.Z)({}, _param);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Headline, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Category, {
                children: props.category
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                children: [
                    props.title,
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: props.highlight
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var components_Headline = (Text);


/***/ }),

/***/ 7818:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var styles_stitches_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4767);
/* harmony import */ var polished__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7573);


var Text = (0,styles_stitches_config__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)("p", {
    fontFamily: "$raleway",
    fontSize: (0,polished__WEBPACK_IMPORTED_MODULE_1__/* .rem */ .hO)(13),
    lineHeight: "180%",
    variants: {
        align: {
            center: {
                textAlign: "center"
            }
        },
        type: {
            semiBold: {
                fontWeight: 600
            },
            bold: {
                fontWeight: "bold"
            },
            lead: {
                fontSize: (0,polished__WEBPACK_IMPORTED_MODULE_1__/* .rem */ .hO)(11),
                fontWeight: 600,
                "@xxl": {
                    fontSize: (0,polished__WEBPACK_IMPORTED_MODULE_1__/* .rem */ .hO)(18)
                }
            }
        },
        size: {
            sm: {
                fontSize: (0,polished__WEBPACK_IMPORTED_MODULE_1__/* .rem */ .hO)(12)
            }
        }
    }
});
/* harmony default export */ __webpack_exports__["Z"] = (Text);


/***/ }),

/***/ 765:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ index_page; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(9534);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(6066);
// EXTERNAL MODULE: ./components/Navbar/index.js + 4 modules
var Navbar = __webpack_require__(6697);
// EXTERNAL MODULE: ./components/Container/index.tsx
var Container = __webpack_require__(1344);
// EXTERNAL MODULE: ./components/Button/index.tsx
var Button = __webpack_require__(8859);
// EXTERNAL MODULE: ./node_modules/slick-carousel/slick/slick.css
var slick = __webpack_require__(8322);
// EXTERNAL MODULE: ./node_modules/slick-carousel/slick/slick-theme.css
var slick_theme = __webpack_require__(2739);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icons/dist/index.esm.js
var index_esm = __webpack_require__(3382);
;// CONCATENATED MODULE: ./public/banner_gramas_small-compressed.webp
/* harmony default export */ var banner_gramas_small_compressed = ({"src":"/_next/static/media/banner_gramas_small-compressed.2a5e3ae0.webp","height":720,"width":1080,"blurDataURL":"data:image/webp;base64,UklGRkIAAABXRUJQVlA4IDYAAACwAQCdASoIAAUAAkA4JagCdADze7UQAPzZa26R7nudAZRXVua/8hTb+UpK/ZGLewusDfQMAAA="});
;// CONCATENATED MODULE: ./public/images/mask-banner-home.svg
/* harmony default export */ var mask_banner_home = ({"src":"/_next/static/media/mask-banner-home.738ce7be.svg","height":87,"width":1920});
// EXTERNAL MODULE: ./styles/stitches.config.ts
var stitches_config = __webpack_require__(4767);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 6 modules
var polished_esm = __webpack_require__(7573);
// EXTERNAL MODULE: ./components/Typography/Text/index.tsx
var Text = __webpack_require__(7818);
;// CONCATENATED MODULE: ./pages/components/Banner/styles.ts






var Banner = (0,stitches_config/* styled */.zo)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
    position: "relative"
}, (0,polished_esm/* size */.dp)("auto", "100%")), {
    paddingTop: 40,
    paddingBottom: 40,
    height: "75vh",
    "& .slick-prev:before, & .slick-next:before": {
        display: "none"
    },
    "& .slick-prev": {
        left: 30,
        top: "30%"
    },
    "& .slick-next": {
        right: 50,
        top: "30%"
    },
    "&::before": (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        content: "",
        position: "absolute",
        top: 0,
        left: 0
    }, (0,polished_esm/* size */.dp)("100%")), {
        backgroundColor: "$emerald200",
        opacity: 0.38,
        zIndex: 2
    }),
    "@sm": {
        height: "45vh"
    },
    "@md": {
        height: "60vh"
    },
    "@lg": {
        height: "75vh"
    },
    "@xl": {
        height: "90vh"
    },
    "@xxl": {
        height: "80vh"
    },
    "& h2": {
        color: "$emerald500",
        marginBottom: 15
    }
}));
var Image_Wrap = (0,stitches_config/* styled */.zo)("div", {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    zIndex: 1
});
var TextTop = (0,stitches_config/* styled */.zo)(Text/* default */.Z, {
    color: "$grey500",
    mb: 10,
    "& span": {
        color: "$emerald500"
    }
});
var Content = (0,stitches_config/* styled */.zo)("div", {
    position: "relative",
    zIndex: 5
});
var Mask_Wrap = (0,stitches_config/* styled */.zo)("div", {
    position: "absolute",
    bottom: -35,
    left: 0,
    width: "100%",
    height: 80,
    zIndex: 4,
    display: "none",
    "@md": {
        display: "block"
    }
});
var Mask = (0,stitches_config/* styled */.zo)((image_default()), {});
var scaleUp = (0,stitches_config/* keyframes */.F4)({
    "0%": {
        transform: "scale(1)"
    },
    "50%": {
        transform: "scale(1.2)"
    },
    "100%": {
        transform: "scale(1)"
    }
});
var Box = (0,stitches_config/* styled */.zo)("div", {
    width: "max-content !important",
    padding: "25px",
    margin: "30px auto 0",
    textAlign: "center",
    borderRadius: "0 0 50px 50px",
    background: "linear-gradient(0deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 100%)",
    "@md": {
        margin: "75px auto 0"
    },
    "@xxl": {
        padding: 56,
        margin: "128px auto 0",
        maxWidth: 800
    },
    "h2": {
        textTransform: "capitalize"
    },
    "@maxmd": {
        margin: "0 auto",
        "h2": {
            fontSize: "1.1rem !important"
        }
    },
    "a > button": {
        animation: "".concat(scaleUp, " 1s ease-in-out infinite")
    }
});
var BoxSubTitle = (0,stitches_config/* styled */.zo)(Text/* default */.Z, {
    color: "$grey600",
    marginBottom: 15
});
var Slider = (0,stitches_config/* styled */.zo)("div", {
    marginTop: 50,
    textAlign: "center"
});

;// CONCATENATED MODULE: ./pages/components/Banner/index.tsx















var BackArrow = function(_param) /*#__PURE__*/ {
    var currentSlide = _param.currentSlide, slideCount = _param.slideCount, props = (0,_object_without_properties/* default */.Z)(_param, [
        "currentSlide",
        "slideCount"
    ]);
    return (0,jsx_runtime.jsx)(Content, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* ArrowBackIcon */.Rp, {
            w: 10,
            h: 10,
            color: "white"
        })
    }));
};
var NextArrow = function(_param) /*#__PURE__*/ {
    var currentSlide = _param.currentSlide, slideCount = _param.slideCount, props = (0,_object_without_properties/* default */.Z)(_param, [
        "currentSlide",
        "slideCount"
    ]);
    return (0,jsx_runtime.jsx)(Content, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* ArrowForwardIcon */.mr, {
            w: 10,
            h: 10,
            color: "white"
        })
    }));
};
var Banner_Banner = function(param) {
    var banner = param.banner;
    var settings = {
        dots: false,
        arrows: true,
        speed: 500,
        autoplay: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(BackArrow, {}),
        nextArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextArrow, {}),
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    dots: true,
                    arrows: false
                }
            }, 
        ]
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Banner, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(TextTop, {
                            size: "sm",
                            align: "center",
                            children: [
                                "Bem vindo a ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "Central da Grama."
                                }),
                                " N\xf3s fornecemos as melhores gramas para voc\xea."
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar/* default */.Z, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, settings), {
                                children: banner === null || banner === void 0 ? void 0 : banner.map(function(item) {
                                    var ref, ref1, ref2, ref3;
                                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(Box, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                        children: item.title.rendered
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BoxSubTitle, {
                                                        type: "lead",
                                                        children: (ref = item.excerpt.rendered) === null || ref === void 0 ? void 0 : ref.replace(/<[^>]*>?/gm, "")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: item === null || item === void 0 ? void 0 : (ref1 = item.acf) === null || ref1 === void 0 ? void 0 : ref1.button_action,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                    shape: "rounded",
                                                    title: item === null || item === void 0 ? void 0 : (ref2 = item.acf) === null || ref2 === void 0 ? void 0 : ref2.button_title,
                                                    children: item === null || item === void 0 ? void 0 : (ref3 = item.acf) === null || ref3 === void 0 ? void 0 : ref3.button_text
                                                })
                                            })
                                        ]
                                    }, item.id);
                                })
                            }))
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_Wrap, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: banner_gramas_small_compressed,
                    layout: "fill",
                    alt: "banner contendo grama",
                    // placeholder="blur"
                    priority: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Mask_Wrap, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Mask, {
                    src: mask_banner_home,
                    alt: "mascara do banner",
                    layout: "fill",
                    objectFit: "cover"
                })
            })
        ]
    });
};
/* harmony default export */ var components_Banner = (Banner_Banner);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/media-query/dist/index.esm.js
var dist_index_esm = __webpack_require__(1469);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var layout_dist_index_esm = __webpack_require__(8641);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/Headline/index.tsx + 1 modules
var Headline = __webpack_require__(2556);
// EXTERNAL MODULE: ./components/Card/index.tsx + 3 modules
var Card = __webpack_require__(4143);
;// CONCATENATED MODULE: ./pages/components/Grass/styles.ts


var Grass = (0,stitches_config/* styled */.zo)("section", {});
var styles_Button = (0,stitches_config/* styled */.zo)(Button/* default */.Z, {
    position: "relative",
    marginTop: 70,
    display: "inline-flex",
    alignItems: "center",
    left: "50%",
    transform: "translateX(-50%)",
    "& svg": {
        marginLeft: 5,
        marginTop: "-2px"
    }
});

// EXTERNAL MODULE: ./utils/index.js
var utils = __webpack_require__(5313);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
;// CONCATENATED MODULE: ./pages/components/Grass/index.tsx











var getSplittedName = function(value) {
    var ref = (0,_sliced_to_array/* default */.Z)(value.toLowerCase().split("GRAMA "), 1), name = ref[0];
    return name;
};
var Grass_Grass = function(param) {
    var grasses = param.grasses;
    var router = (0,next_router.useRouter)();
    var isMobile = (0,dist_index_esm/* useBreakpointValue */.Sx)({
        base: true,
        md: false
    });
    var grassesList = isMobile ? grasses === null || grasses === void 0 ? void 0 : grasses.slice(0, 3) : grasses;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grass, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Headline/* default */.Z, {
                    category: "Gramas",
                    title: "Tipos de",
                    highlight: "Grama"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* SimpleGrid */.MI, {
                    columns: [
                        1,
                        1,
                        2,
                        null,
                        3
                    ],
                    spacing: 15,
                    children: grassesList === null || grassesList === void 0 ? void 0 : grassesList.map(function(item) {
                        var ref, ref1, ref2;
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(Card/* default */.Z, {
                            image: (0,utils/* transformHttpToHttps */.T)(item.x_featured_media_original),
                            title: getSplittedName(item.title.rendered),
                            description: "".concat(item.excerpt.rendered, " ..."),
                            onPress: function() {
                                return router.push(item.slug);
                            },
                            metaImgTitle: item === null || item === void 0 ? void 0 : (ref = item.acf) === null || ref === void 0 ? void 0 : ref.title_img_othergrass,
                            metaImgAlt: item === null || item === void 0 ? void 0 : (ref1 = item.acf) === null || ref1 === void 0 ? void 0 : ref1.alt_img_othergrass,
                            metaTitle: item === null || item === void 0 ? void 0 : (ref2 = item.acf) === null || ref2 === void 0 ? void 0 : ref2.title_text_othergrass
                        }, "grass-".concat(item.id));
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/dicas",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_Button, {
                        shape: "rounded",
                        as: "a",
                        href: "/dicas",
                        title: "ver todas as dicas de grama",
                        children: [
                            "Ver todas ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* ArrowForwardIcon */.mr, {
                                w: 4,
                                h: 4
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var components_Grass = (Grass_Grass);

;// CONCATENATED MODULE: ./pages/components/CTA/styles.ts

var Cta = (0,stitches_config/* styled */.zo)("section", {
    backgroundColor: "$emerald500",
    textAlign: "center"
});
var styles_Content = (0,stitches_config/* styled */.zo)("div", {
    maxWidth: 750,
    margin: "0 auto",
    "& h2": {
        marginBottom: 15,
        color: "$white"
    },
    "& p": {
        color: "$white",
        marginBottom: 30
    },
    "& button": {
        margin: "0 auto",
        "& svg": {
            marginLeft: 5,
            marginTop: "-2px"
        }
    }
});

;// CONCATENATED MODULE: ./pages/components/CTA/index.tsx







var CTA_Cta = function() {
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Cta, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_Content, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        children: "Tenha o melhor pre\xe7o de grama para o seu jardim"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        type: "semiBold",
                        children: "Encontre a melhor grama para o seu jardim com pre\xe7os imbat\xedveis. Fa\xe7a agora mesmo o seu or\xe7amento e garanta a beleza do seu espa\xe7o verde. N\xe3o perca mais tempo, aproveite j\xe1!"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                        color: "inverse",
                        shape: "rounded",
                        onClick: function() {
                            return router.push("/comprar-grama");
                        },
                        title: "comprar grama para jardim",
                        children: [
                            "fa\xe7a seu or\xe7amento",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* ArrowForwardIcon */.mr, {
                                w: 4,
                                h: 4
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var CTA = (CTA_Cta);

// EXTERNAL MODULE: ./components/Footer/index.tsx + 2 modules
var Footer = __webpack_require__(7386);
;// CONCATENATED MODULE: ./pages/styles.home.ts

var Main = (0,stitches_config/* styled */.zo)("main", {
    "& section": {
        paddingTop: 100,
        paddingBottom: 100
    }
});

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./pages/index.page.tsx








var Utilzation = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 128).then(__webpack_require__.bind(__webpack_require__, 6128));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6128)
            ];
        }
    },
    ssr: false
});
var Tips = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(345), __webpack_require__.e(538), __webpack_require__.e(542)]).then(__webpack_require__.bind(__webpack_require__, 2542));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(2542)
            ];
        }
    },
    ssr: false
});
var Customers = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(345), __webpack_require__.e(285)]).then(__webpack_require__.bind(__webpack_require__, 1285));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(1285)
            ];
        }
    },
    ssr: false
});
var Home = function(param) {
    var grasses = param.grasses, banner = param.banner, utilizations = param.utilizations, tips = param.tips, customers = param.customers;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Comprar grama \xe9 na Central, gramas pelo menor pre\xe7o m2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "title",
                        content: "Comprar grama \xe9 na Central, gramas pelo menor pre\xe7o m2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "Gramas para jardim, Campo de Futebol, Taludes, Paisagismo, Obras em geral. Pre\xe7o ainda mais baixo ao Comprar a Grama c/ Plantio, Acesse a Central."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "keywords",
                        content: "grama, gramas, gramas por m2, comprar grama, comprar gramas, comprar grama por m2, grama pre\xe7o, grama pre\xe7o m2, grama natural"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: "https://centraldagrama.com/"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: "Comprar grama \xe9 na Central, gramas pelo menor pre\xe7o m2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: "Gramas para jardim, Campo de Futebol, Taludes, Paisagismo, Obras em geral. Pre\xe7o ainda mais baixo ao Comprar a Grama c/ Plantio, Acesse a Central."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: "https://metatags.io/assets/meta-tags-16a33a6a8531e519cc0936fbba0ad904e52d35f34a46c97a2c9f6f7dd7d336f2.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "twitter:url",
                        content: "https://centraldagrama.com/"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "twitter:title",
                        content: "Comprar grama \xe9 na Central, gramas pelo menor pre\xe7o m2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "twitter:description",
                        content: "Gramas para jardim, Campo de Futebol, Taludes, Paisagismo, Obras em geral. Pre\xe7o ainda mais baixo ao Comprar a Grama c/ Plantio, Acesse a Central."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "twitter:image",
                        content: "https://metatags.io/assets/meta-tags-16a33a6a8531e519cc0936fbba0ad904e52d35f34a46c97a2c9f6f7dd7d336f2.png"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Main, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Banner, {
                        banner: banner
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Grass, {
                        grasses: grasses
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Utilzation, {
                        utilizations: utilizations
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CTA, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tips, {
                        tips: tips
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Customers, {
                        customers: customers
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {})
                ]
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var index_page = (Home);


/***/ }),

/***/ 5313:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ countComments; },
/* harmony export */   "T": function() { return /* binding */ transformHttpToHttps; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9815);



var countComments = function(comments) {
    var flatComments = comments.flatMap(function(comment) {
        if (comment.replies) {
            return [
                (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, comment), {
                    replies: false
                })
            ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(comment.replies.map(function(reply) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, reply), {
                    status: false
                });
            })));
        }
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, comment), {
            replies: false
        });
    });
    var commentsActive = flatComments.filter(function(item) {
        return item.status;
    });
    return (commentsActive === null || commentsActive === void 0 ? void 0 : commentsActive.length) || 0;
};
var transformHttpToHttps = function(url) {
    if (!url) return "";
    return url.replace("http://", "https://");
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [753,641,112,774,888,179], function() { return __webpack_exec__(9208); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);